import apiHeader from '@/helpers/apiHeader';

const companiesService = {
    list(params) {
        return apiHeader.get('general-master-data/company', { params });
    },
    get(id) {
        return apiHeader.get(`companies/${id}`);
    },
    update(params) {
        return apiHeader.post('companies/', params);
    },
    create(params) {
        return apiHeader.post('general-master-data/company', params);
    },
    delete(id) {
        return apiHeader.delete(`general-master-data/company/${id}`);
    },
    detail(id) {
        return apiHeader.get(`general-master-data/company/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`general-master-data/company/${id}`, params);
    },
}

export default companiesService;
